import { qualifications, occupations, genderTypes } from '@/services/globaldata'
import { find } from 'lodash'

export function basicInfo (data) {
  const basicInfo = {
    'First Name': data.first_name,
    'Last Name': data.last_name,
    'Qualification': find(qualifications, { 'value': data.qualification }).name,
    'Occupation': find(occupations, { 'value': data.occupation }).name,
    'Income': data.income ? thousandsSeparators(data.income) : '',
    'Office Address': data.office_address,
    'Gender': find(genderTypes, { 'value': data.gender }).name,
  }

  return basicInfo
}

export function contactInfo (data) {
  const contactInfo = {
    'Address': data.address,
    'Landmark': data.landmark,
    'Pincode': data.pincode,
    'City': data.city,
    'State': data.state,
    'Country': data.country,
    'Phone': data.phone ? data.country_code + '' + data.phone : '',
    'Alt Phone': data.alt_phone ? data.alt_country_code + '' + data.alt_phone : '',
    'Email': data.email,
  }

  return contactInfo
}

function thousandsSeparators(num) {
  var numParts = num.toString().split('.')
  numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return numParts.join('.')
}
